import React, { Component } from 'react';
import Pelayanan from './Pelayanan';
import PelayananPx from './PelayananPx';
import { DetilPxContext } from '../../context';

export default class ContainerPelayanan extends Component {
  state = {
    detilPx: {},
    onService: false
  };

  changeDetilPx = data => {
    this.setState({
      detilPx: data,
      onService: true
    });
  };

  static getDerivedStateFromProps(props) {
    if (props.history.location.pathname === '/pelayanan') {
      return { onService: false };
    } else {
      return null;
    }
  }

  render() {
    const onService = this.state.onService;
    return (
      <DetilPxContext.Provider
        value={ { data: this.state.detilPx, changeDetilPx: this.changeDetilPx } }
      >
        {onService ? (
          <PelayananPx { ...this.props } />
        ) : (
          <Pelayanan { ...this.props }></Pelayanan>
        )}
      </DetilPxContext.Provider>
    );
  }
}
